// extracted by mini-css-extract-plugin
module.exports = {"pclTagline":"style_pclTagline__oMH51","pbiHeading":"style_pbiHeading__Pm2y4"};